import { render, staticRenderFns } from "./WrapperDeliveryMngt.vue?vue&type=template&id=60c2d24a"
import script from "./WrapperDeliveryMngt.vue?vue&type=script&lang=js"
export * from "./WrapperDeliveryMngt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports